const dic = {
  day: 24 * 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  minute: 60 * 1000,
  second: 1000,
  tenMs: 10
};

function spanZero(num) {
  if (num >= 0 && num < 10) {
    return '0' + num
  }
  return '' + num
}

function spanZeroRes(res){
  res.day = spanZero(res.day);
  res.hour = spanZero(res.hour);
  res.minute = spanZero(res.minute);
  res.second = spanZero(res.second);
  res.tenMs = spanZero(res.tenMs);
  return res
}

/**
 *
 * @param ms 倒计时时间
 * @param withDay 是否计算有多少天
 * @returns {{day: number, hour: number, minute: number, second: number, tenMs: number}}
 */
export function countDown(ms, withDay = false) {
  const res = {
    day: 0,//日
    hour: 0,//小时
    minute: 0,//分钟
    second: 0, //秒
    tenMs: 0 //10ms
  };


  if (ms > 0) {

    if (withDay) {
      if (ms > dic.day) {
        res.day = Math.floor(ms / dic.day)
        ms -= (res.day * dic.day);
      } else {
        res.day = 0
      }
    }

    if (ms > res.hour) {
      res.hour = Math.floor(ms / dic.hour)
      ms -= (res.hour * dic.hour);
    } else {
      res.hour = 0
    }


    res.minute = Math.floor(ms / dic.minute)
    ms -= (res.minute * dic.minute);

    res.second = Math.floor(ms / dic.second)
    ms -= (res.second * dic.second);

    res.tenMs = Math.floor(ms / dic.tenMs);

  }

  spanZeroRes(res);
  // console.log(res)
  return res;
}

// console.log(countDown(3000))
// console.log(countDown(30 * 1000))
// console.log(countDown(2222 + 30 * 1000))
// console.log(countDown(1111111111111111111))
// console.log(countDown(1111111111111111111,true))
